import { hasValue } from '@app/shared/comparison-helpers.service';

export const validateNotNullFields = (object: Object, notNullFields: string[]): string[] => {
  const messages = [];

  for (const field in notNullFields) {
    if (!hasValue(object[notNullFields[field]])) {
      messages.push(`${object.constructor.name} contains a null value at ${notNullFields[field]}`);
    }
  }
  return messages;
};
